module.exports = __webpack_public_path__ + "static/media/slicica-01.c2e87a46.jpg";